import { useId, useState } from "react";

import realEstateColumns from "mock/real-estate-solutions";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import Container from "components/grid/container";
import Button from "components/common/button";
import Input from "components/common/input";
import { LazyImage } from "src/components/common/lazy-image/LazyImage";
import Modal from "components/common/modal";
import { useEnvContext } from "next-runtime-env";

import styles from "./styles.module.css";

export const RealEstateSolutions = () => {
  const keyId = useId();
  const [isShowYoutubeModal, setIsShowYoutubeModal] = useState(false);
  const { NEXT_PUBLIC_EJ_APP_CANONICAL_HOST } = useEnvContext();

  const handleShowYoutubeModal = () => {
    setIsShowYoutubeModal(true);
  };

  const handleSetGa4Event = (eventLabel) => {
    Ga4WithEventParameters({
      eventName: "click_widget",
      eventParameters: { widget: `gayrimenkul-mu-ariyorsun||${eventLabel}` },
    });
  };

  return (
    <div className={styles.wrapper}>
      <Container>
        <h2 className={styles.sectionTitle}>Gayrimenkul Çözümleri</h2>
        <div className={styles.columns}>
          {realEstateColumns.map((column, index) => {
            const {
              logo,
              title,
              subTitle,
              buttonText,
              buttonHref,
              isTopHeadColumn,
              badge,
              media,
              searchItems,
              isYoutubeComponent,
              eventLabel,
            } = column;
            if (isTopHeadColumn) {
              return (
                <div className={styles.headColumn} key={`${keyId}${index}`}>
                  <div className={styles.headColumnInfoLeft}>
                    <div className={styles.headColumnIcon}>{logo}</div>
                    <div className={styles.titleWrapper}>
                      <div className={styles.title}>{title}</div>
                      {badge && <div className={styles.badge}>{badge}</div>}
                    </div>
                    <div className={styles.subTitle}>{subTitle}</div>
                    {!searchItems && (
                      <div className={styles.buttonWrapper}>
                        <Button blankTarget href={buttonHref} size="M" onClick={() => handleSetGa4Event(eventLabel)}>
                          {buttonText}
                        </Button>
                      </div>
                    )}
                    {searchItems && (
                      <div className={styles.searchWrap}>
                        <label className={styles.searchLabel}>{searchItems.label}</label>
                        <div className={styles.searchInner}>
                          <div className={styles.inputWrapper}>
                            <Input maxLength={searchItems.inputMaxLength} placeholder={searchItems.inputPlaceholder} />
                          </div>
                          <div className={styles.buttonWrapper}>
                            <Button
                              blankTarget
                              href={`${NEXT_PUBLIC_EJ_APP_CANONICAL_HOST}/emlak-yatirim-uzmani/`}
                              size="M"
                              onClick={() => handleSetGa4Event(eventLabel)}
                            >
                              {searchItems.buttonText}
                            </Button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className={styles.headColumnYoutubeVideoRight}>
                    <div
                      className={styles.youtubeVideoThumbnail}
                      onClick={isYoutubeComponent ? handleShowYoutubeModal : null}
                    >
                      <LazyImage className={styles.thumbnailImage} src={media} alt="Emlakjet - Gayrimenkul Çözümleri" />
                    </div>
                  </div>
                </div>
              );
            }
            return (
              <div className={styles.columnWrapper} key={`${keyId}-${index}`}>
                <div className={styles.logoWrapper}>{logo}</div>
                <div className={styles.infoWrapper}>
                  <div className={styles.titleWrapper}>
                    <p className={styles.title}>{title}</p>
                    {badge && <div className={styles.badge}>{badge}</div>}
                  </div>
                  <p className={styles.subTitle}>{subTitle}</p>
                  <div className={styles.buttonWrapper}>
                    <Button blankTarget href={buttonHref} size="M" onClick={() => handleSetGa4Event(eventLabel)}>
                      {buttonText}
                    </Button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <Modal isOpen={isShowYoutubeModal} handleClose={() => setIsShowYoutubeModal(false)}>
          <div className={styles.iframeWrapper}>
            <iframe
              width="auto"
              height="auto"
              src="https://www.youtube.com/embed/DYsBJ8GWiko?si=U0gT-3-Pcr1AmcCJ"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
              className="video"
            />
          </div>
        </Modal>
      </Container>
    </div>
  );
};
